import React from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import Icon from "@material-ui/core/Icon";
import Slide from '@material-ui/core/Slide';
// @material-ui/icons
// import Close from "@material-ui/icons/Close";
// import Assignment from "@material-ui/icons/Assignment";
// import Face from "@material-ui/icons/Face";
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
// import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TextField from '@material-ui/core/TextField';
// import MenuItem from '@material-ui/core/MenuItem';
import Button from "components/CustomButtons/Button.jsx";
// import Card from "components/Card/Card.jsx";
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import NumberFormat from 'react-number-format';

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

// const currencies = [
//   {
//     value: 'USD',
//     label: '$',
//   },
//   {
//     value: 'EUR',
//     label: '€',
//   },
//   {
//     value: 'BTC',
//     label: '฿',
//   },
//   {
//     value: 'JPY',
//     label: '¥',
//   },
// ];

function Transition(props) {
  return <Slide direction="down" {...props} />;
}



function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  // console.log(values);
  //console.log(inputRef);
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            id: "price",
            value: values.value,

          },
        });

      }}
      thousandSeparator

    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


class AddPropertySecondData extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  // }

  render() {
    const { classes } = this.props;

    return (


              <GridContainer>

                <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>

                  <TextField
                      id="name_public"
                      name="name_public"
                      label="Public name"
                      name="name"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.name_public.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />

                </GridItem>

                <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>

                </GridItem>


                <GridItem xs={12} sm={11} md={11} className={classes.mlAuto}>
                  <TextField
                      id="short_description_public"
                      name="short_description_public"
                      label="Short description, public"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      multiline
                      rows={2}
                      variant="outlined"
                      value={this.props.propertyData.short_description_public.value}
                      onChange={(e) => this.props.changeHandler(e)}

                    />

                </GridItem>

                <GridItem xs={12} sm={11} md={11} className={classes.mlAuto}>
                  <TextField
                      id="description_public"
                      name="description_public"
                      label="Description, public"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      multiline
                      rows={4}
                      variant="outlined"
                      value={this.props.propertyData.description_public.value}
                      onChange={(e) => this.props.changeHandler(e)}

                    />

                </GridItem>


              </GridContainer>

    );
  }
}

export default withStyles(javascriptStyles)(AddPropertySecondData);
